module.exports = __webpack_public_path__ + "img/sn.58bee3ab.png";